import { IBreadcrumbDto } from "../contract";

/**
 * Maps API breadcrumb format to BreadCrumbs component format
 */

const DEFAULT_BREADCRUMB = {
  label: "Help & Support",
  url: "/help-support/",
};

const mapBreadcrumbs = (
  breadcrumbs: IBreadcrumbDto[] | undefined
): { label: string; url: string }[] => {
  if (!breadcrumbs) return [];

  const formattedBreadcrumbs = breadcrumbs.map((breadcrumb) => ({
    label: breadcrumb.name,
    url: breadcrumb.uri,
  }));

  // if Help & Support is not the first breadcrumb, add it manually
  if (
    formattedBreadcrumbs.length === 0 ||
    formattedBreadcrumbs[0].label !== DEFAULT_BREADCRUMB.label
  ) {
    formattedBreadcrumbs.unshift(DEFAULT_BREADCRUMB);
  }

  return formattedBreadcrumbs;
};

export default mapBreadcrumbs;
